import React from 'react';

import { useProfileState, useProfileActions } from './ProfileContext';

import Divider from '../../Shared/UI/Divider/components/Divider';
import Button from '../../Shared/UI/Button/components/Button';
import PlusIcon from '../../Shared/UI/PlusIcon/components/PlusIcon';
import ProfileUserInterest from './ProfileUserInterest';
import InterestsModal from './InterestsModal';

import styles from './ProfileUserInterests.module.scss';

const ProfileUserInterests = () => {
  const state = useProfileState();
  const { openUserInterestsModal } = useProfileActions();

  if (state.loading) {
    return (
      <section id={styles.userInterestsSection}>
        <Divider />
        <div id={styles.userInterestsLoading} />
      </section>
    );
  }

  if (state?.user?.isAuthenticatedUser && state?.user?.interests?.length) {
    return (
      <>
        <section id={styles.userInterestsSection}>
          <Divider />
          <div id={styles.userInterestsSectionHeader}>
            <h2>
              Interests
            </h2>
            <Button
              variant="ghost"
              icon={<PlusIcon />}
              iconOnly
              aria-label="Add Interest"
              onClick={() => {
                openUserInterestsModal();
              }}
            />
          </div>
          <div id={styles.userInterests}>
            {state.user?.interests?.map((interest) => {
              return <ProfileUserInterest key={interest.id} interest={interest} />;
            })}
          </div>
        </section>
        <InterestsModal />
      </>
    );
  }

  if (state?.user?.isAuthenticatedUser && !state?.user?.interests?.length) {
    return (
      <>
        <section id={styles.userInterestsSection}>
          <Divider />
          <div id={styles.userInterestsSectionHeader}>
            <h2 className={styles.visibleOnlyToYou}>
              Interests
            </h2>
            <Button
              variant="ghost"
              icon={<PlusIcon />}
              iconOnly
              aria-label="Add Interest"
              onClick={() => {
                openUserInterestsModal();
              }}
            />
          </div>
          <p className={styles.visibleOnlyToYou}>
            This section is currently only visible to you since you have not claimed any interests to display yet.
          </p>
        </section>
        <InterestsModal />
      </>
    );
  }

  if (!state?.user?.isAuthenticatedUser && state?.user?.interests?.length) {
    return (
      <>
        <section id={styles.userInterestsSection}>
          <Divider />
          <h2>
            Interests
          </h2>
          <div id={styles.userInterests}>
            {state?.user?.interests?.map((interest) => {
              return <ProfileUserInterest key={interest.id} interest={interest} />;
            })}
          </div>
        </section>
      </>
    );
  }

  if (!state?.user?.isAuthenticatedUser && !state?.user?.interests?.length) {
    return null;
  }
};

export default ProfileUserInterests;
